export default __webpack_public_path__ + "static/polo-avatar-af265697eff252fe496dca36b20c7f82.png";